export function getLoggableError(error: unknown): Error {
  if (error instanceof Error) {
    return error;
  }
  if (typeof error === 'string') {
    return new Error(error);
  }
  return new Error('Unsupported error format. Check cause for details.', {
    cause: error,
  });
}
